import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash.get';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import InViewObserver from 'components/InViewObserver/InViewObserver';
import Cookie from 'utils/cookies';
import s from './NewStreakCard.scss';

const NewStreakCard = props => {
  const {
    streakData,
    dateInfo,
    isMobile,
    gameId,
    gameType,
    gameLevel,
    isUserLoggedIn,
    openLoginBox,
    gamesconfigData,
  } = props;

  let grxId = Cookie.get('_grx');
  let ssoId = Cookie.get('ssoid');
  grxId = grxId || '';
  ssoId = ssoId || '';

  const translations = _get(gamesconfigData, 'translations', {});
  const commonTranslations = _get(
    translations,
    'streakTranslations.common',
    {},
  );

  const renderPerformancePanel = () => {
    const today = new Date();
    const days = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

    // Use dateInfo if provided, otherwise fallback to generated week dates
    const weekDates =
      dateInfo ||
      Array.from({ length: 7 }, (_, i) => {
        const date = new Date(today);
        date.setDate(today.getDate() - today.getDay() + i);
        return {
          date: date.getDate(),
          day: days[date.getDay()],
          isToday: date.toDateString() === today.toDateString(),
          isCompleted: true,
        };
      });

    return (
      <div className={s.streakWrap}>
        {isUserLoggedIn ? (
          <h2 className={s.title}>Performance so far…</h2>
        ) : (
          <h2 className={s.title}>Keep the momentum going</h2>
        )}
        <InViewObserver
          inViewCallback={() => {
            const gaData = {
              event: 'user_shown_games',
              type: 'streak_widget',
              label:
                isUserLoggedIn && streakData && streakData.maxStreak
                  ? streakData.maxStreak
                  : 'login_to_begin_a_streak',
              page_template: 'gameplay',
              section: 'games',
              subsection:
                gameType === 'loop-a-loop'
                  ? 'loop_the_loop'
                  : gameType?.replace(/-/g, '_'),
              browsing_platform: isMobile ? 'mweb' : 'web',
              game_id: gameId,
              level: gameLevel || 'N/A',
              game_of_the_day: window.location.href
                .toLowerCase()
                .includes('/today'),
              login_status: !!ssoId,
              user_grx_id: grxId,
            };
            if (ssoId) {
              gaData.sso_id = ssoId;
            }
            analyticsWrapper('ga4', gaData);
            analyticsWrapper('grx', 'track', 'user_shown_games', gaData);
          }}
        >
          <div className={s.streakPanel}>
            <div
              className={`${s.streakDaysWrap} ${gameType ? `${gameType}` : ''}`}
            >
              {isUserLoggedIn ? (
                <div className={s.streakPanelHeader}>
                  <div className={s.streakTitle}>
                    <strong>
                      {streakData?.streakInfo?.streakTitle
                        ? streakData.streakInfo.streakTitle
                        : 'Active Streak'}
                    </strong>
                    {/* <span>to claim your streak!</span> */}
                  </div>
                  <div className={s.activeStreak}>
                    <i
                      className={`${s.streakIcon} ${
                        isUserLoggedIn ? '' : s.streakIconLock
                      }`}
                    />
                    {streakData && streakData.streakInfo ? (
                      <div className={s.streakDayCount}>
                        {streakData &&
                          streakData?.streakInfo &&
                          streakData?.streakInfo?.count && (
                            <strong>{streakData.streakInfo.count}</strong>
                          )}
                        <span>
                          {streakData?.streakInfo?.count &&
                          (streakData?.streakInfo?.count === 0 ||
                            streakData?.streakInfo?.count === 1)
                            ? 'Day'
                            : 'Days'}
                        </span>
                      </div>
                    ) : (
                      <div className={s.streakDayCount}>
                        <strong>No</strong>
                        <span>Active Streak</span>
                      </div>
                    )}
                  </div>
                </div>
              ) : (
                <div className={s.streakPanelHeader}>
                  <div className={s.streakTitle}>
                    <strong>Login / Sign Up</strong>
                    <span>to claim your streak!</span>
                  </div>
                  <div className={s.activeStreak}>
                    <i className={`${s.streakIcon} ${s.streakIconLock}`} />
                  </div>
                </div>
              )}

              <div className={s.streakDaysContainer}>
                <div className={s.streakDaysGrid}>
                  {weekDates.map((day, index) => {
                    let circleClass = s.dayCircle;
                    if (day.isCompleted) {
                      circleClass += ` ${s.dayCompleted}`;
                    } else if (day.isToday) {
                      circleClass += ` ${s.dayToday}`;
                    } else {
                      circleClass += ` ${s.dayUpcoming}`;
                    }

                    return (
                      <div key={index} className={circleClass}>
                        <div
                          className={
                            s.dayNumber +
                            (day && day.hasPlayed ? ` ${s.dayCompleted}` : '')
                          }
                        >
                          {isUserLoggedIn ? (
                            <>
                              {day && day.hasPlayed ? (
                                <>{day?.date}</>
                              ) : (
                                <>
                                  {day && day.hasPlayed === false ? (
                                    <i className={s.iconCross} />
                                  ) : (
                                    <>{day.date}</>
                                  )}
                                </>
                              )}
                            </>
                          ) : (
                            <i className={s.iconLock} />
                          )}
                        </div>
                        <span className={s.dayName}>{day?.day}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>

            <div className={s.streakInfoWrap}>
              <div className={s.streakInfoData}>
                <div className={s.streakInfoItem}>
                  <span>Played</span>
                  {isUserLoggedIn && streakData && streakData.gamesPlayed ? (
                    <strong className={s.value}>
                      {streakData.gamesPlayed}
                    </strong>
                  ) : (
                    <strong className={s.value}>-</strong>
                  )}
                </div>
                <div className={s.streakInfoItem}>
                  <span>
                    {gameType === 'location-guesser' ? 'Perfects' : 'Best Time'}
                  </span>
                  {isUserLoggedIn && streakData && streakData.bestResult ? (
                    <strong className={s.value}>{streakData.bestResult}</strong>
                  ) : (
                    <strong className={s.value}>-</strong>
                  )}
                </div>
                <div className={s.streakInfoItem}>
                  <span>Max Streak</span>
                  {isUserLoggedIn && streakData && streakData.maxStreak ? (
                    <strong className={s.value}>{streakData.maxStreak}</strong>
                  ) : (
                    <strong className={s.value}>-</strong>
                  )}
                </div>
              </div>

              {!isUserLoggedIn && (
                <button
                  className={s.btnPrimary}
                  onClick={() => {
                    openLoginBox();
                    const gaData = {
                      event: 'user_click_games',
                      type: 'streak_widget',
                      label: 'login_cta',
                      page_template: 'gameplay',
                      section: 'games',
                      subsection:
                        gameType === 'loop-a-loop'
                          ? 'loop_the_loop'
                          : gameType?.replace(/-/g, '_'),
                      browsing_platform: isMobile ? 'mweb' : 'web',
                      game_id: gameId,
                      level: gameLevel || 'N/A',
                      game_of_the_day: window.location.href
                        .toLowerCase()
                        .includes('/today'),
                      login_status: !!ssoId,
                      user_grx_id: grxId,
                    };
                    if (ssoId) {
                      gaData.sso_id = ssoId;
                    }
                    analyticsWrapper('ga4', gaData);
                    analyticsWrapper(
                      'grx',
                      'track',
                      'user_click_games',
                      gaData,
                    );
                  }}
                >
                  {commonTranslations?.loginToBegin || 'Login Now'}{' '}
                  <i className={s.iconArrow} />
                </button>
              )}
            </div>
          </div>
        </InViewObserver>
      </div>
    );
  };

  return <div>{renderPerformancePanel()}</div>;
};

NewStreakCard.propTypes = {
  dateInfo: PropTypes.arrayOf(
    PropTypes.shape({
      day: PropTypes.string,
      date: PropTypes.string,
    }),
  ),
  gameId: PropTypes.string,
  gameType: PropTypes.string,
  gameLevel: PropTypes.string,
  isUserLoggedIn: PropTypes.bool,
  openLoginBox: PropTypes.func,
  gamesconfigData: PropTypes.shape({}),
};

NewStreakCard.defaultProps = {
  dateInfo: null,
  gameId: '',
  gameType: '',
  gameLevel: '',
  isUserLoggedIn: false,
  openLoginBox: () => {},
  gamesconfigData: {},
};

export default NewStreakCard;
